import * as yup from 'yup'

const schemaGroup = () =>
  yup.object().shape({
    name: yup.string().required(),
  })

export default schemaGroup
